import React, {Component} from 'react';
import PropTypes from "prop-types";
import classnames from "classnames";
import validator from "validator";
import {connect} from "react-redux";
import {changePassword} from "../../store/actions/user";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: {
        value: '',
        isValid: false,
        touched: false,
        errorMessage: ''
      },
      password: {
        value: '',
        isValid: false,
        touched: false,
        errorMessage: ''
      },
      confirmPassword: {
        value: '',
        isValid: false,
        touched: false,
        errorMessage: ''
      },
      formValid: false
    };
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.passwordChanged.status === 400) {
      // Highlight password field as invalid password
      this.setState({
        oldPassword: {
          ...this.state.oldPassword,
          isValid: false,
          errorMessage: 'Wrong password.'
        }
      });
      return;
    }

    this.props.closeModal(true);
  }

  handleUserInput(ev) {
    const fieldName = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        value
      }
    }, () => this.validateField(fieldName, value));
  }

  validateField(filedName, value) {
    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    const invalidPasswordMessage = 'Password must be at least 8 characters long containing at least one number and a letter.';
    let oldPasswordValid = this.state.oldPassword.isValid;
    let oldPasswordErrorMessage = this.state.oldPassword.errorMessage;
    let passwordValid = this.state.password.isValid;
    let passwordErrorMessage = this.state.password.errorMessage;
    let confirmPasswordValid = this.state.confirmPassword.isValid;
    let confirmPasswordErrorMessage = this.state.confirmPassword.errorMessage;

    let isValid = false;
    let errorMessage = '';

    switch (filedName) {
      case 'oldPassword':
        oldPasswordValid = value.match(passwordPattern);
        oldPasswordErrorMessage = invalidPasswordMessage;
        isValid = oldPasswordValid;
        errorMessage = oldPasswordErrorMessage;
        break;
      case 'password':
        passwordValid = value.match(passwordPattern);
        passwordErrorMessage = invalidPasswordMessage;
        isValid = passwordValid;
        errorMessage = passwordErrorMessage;
        break;
      case 'confirmPassword':
        confirmPasswordValid = validator.equals(this.state.password.value, value);
        confirmPasswordErrorMessage = 'Passwords do not match.';
        isValid = confirmPasswordValid;
        errorMessage = confirmPasswordErrorMessage;
        break;
      default:
        break;
    }

    this.setState({
      [filedName]: {
        ...this.state[filedName],
        isValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    const {oldPassword, password, confirmPassword} = this.state;

    this.setState({
      formValid: oldPassword.isValid && password.isValid && confirmPassword.isValid
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  onSubmit(ev) {
    ev.preventDefault();

    if (this.state.formValid) {
      const {oldPassword, password, confirmPassword} = this.state;
      const requestBody = {
        old_password: oldPassword.value,
        new_password: password.value,
        new_password_confirm: confirmPassword.value
      };

      this.props.changePassword(this.props.user.id, requestBody);
    }
  }

  render() {
    const {oldPassword, password, confirmPassword} = this.state;

    return (
        <div className="popup">
          <div className="btn-close">
            <button onClick={this.props.closeModal} className="btn btn-link"><i className="icon-close"> </i></button>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-8">
                <div className="form-title">
                  <h1>Change password</h1>
                </div>
                <div className={classnames('form-group', {'invalid': !oldPassword.isValid && oldPassword.touched})}>
                  <input type="password" className="form-control" placeholder="Enter old password *" name="oldPassword"
                         value={oldPassword.value} onBlur={this.handleInputBlur} onChange={this.handleUserInput}/>
                  {!oldPassword.isValid && oldPassword.touched && (
                      <p className="error-msg">{oldPassword.errorMessage}</p>)}
                </div>
                <div className={classnames('form-group', {'invalid': !password.isValid && password.touched})}>
                  <input type="password" className="form-control" placeholder="New password *" name="password"
                         value={password.value} onBlur={this.handleInputBlur} onChange={this.handleUserInput}/>
                  {!password.isValid && password.touched && (
                      <p className="error-msg">{password.errorMessage}</p>)}
                </div>
                <div
                    className={classnames('form-group', {'invalid': !confirmPassword.isValid && confirmPassword.touched})}>
                  <input type="password" className="form-control" placeholder="Confirm new password *"
                         name="confirmPassword" value={confirmPassword.value} onBlur={this.handleInputBlur}
                         onChange={this.handleUserInput}/>
                  {!confirmPassword.isValid && confirmPassword.touched && (
                      <p className="error-msg">{confirmPassword.errorMessage}</p>)}
                </div>
                <div className="form-group text-right mb-4">
                  <button type="button" className="btn btn-lg btn-secondary mr-3" onClick={this.props.closeModal}>Cancel
                  </button>
                  <input type="button" className="btn btn-lg btn-primary" value="Submit"
                         disabled={!this.state.formValid} onClick={this.onSubmit.bind(this)}/>
                </div>
              </form>
            </div>
          </div>
        </div>
    );
  }
}

ChangePassword.propTypes = {
  closeModal: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  passwordChanged: PropTypes.any.isRequired
};

const mapDispatchToProps = dispatch => ({
  changePassword: (userId, data) => dispatch(changePassword(userId, data))
});

const mapStateToProps = state => ({
  user: state.auth.user,
  passwordChanged: state.user.passwordChanged
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/popups/ChangePassword.jsx